import instance from './testing.instance';

export const getLocationServices = (nodeId) =>
    instance.get('/lector/api/localizacion-servicio/', {
        params: { jerarquia: nodeId },
    });

export const createLocationService = (data) =>
    instance.post('/lector/api/localizacion-servicio/', data);

export const updateLocationService = (id, data) =>
    instance.patch(`/lector/api/localizacion-servicio/${id}/`, data);

export const deleteLocationService = (id) =>
    instance.delete(`/lector/api/localizacion-servicio/${id}/`);
